module.exports = __webpack_public_path__ + "img/logo4.88f26a17.png";